export type TreeNode = {
  children?: TreeNode[];
};

export function* createTreeIterator<T extends TreeNode>(tree: T[]): Generator<T> {
  for (const treeItem of tree) {
    yield treeItem;

    if (treeItem.children?.length) {
      yield* createTreeIterator<T>(treeItem.children as T[]);
    }
  }
}
